// extracted by mini-css-extract-plugin
module.exports = {"nav":"AllowedRoutes_nav__3tDRG","active":"AllowedRoutes_active__1-h_V"};